export const magicNumbers = {
  ONE_MINUTE_IN_SECOND: 60,
  FIVE_MINUTE_IN_SECOND: 300,
  YOUR_SEARCH_QUERY_ID: -1,
  MEGA_SUBJECT_QUERY_ID: -9,
  CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE: 2000000000,
  CONTENT_BASED_FILTER_DEFAULT_MIN_VALUE: 0,
  SUBJECT_FILTER_DEFAULT_OPTION: -2,
  INDEX_NOT_FOUND: -1,
  TAB_FIRST_INDEX: 0,
  MAX_VISIBLE_PLATFORM_TABS: 5,
  PLATFORM_TAB_DRAG_START_DISTANCE: 5,
  PLATFORM_TAB_TOUCH_HOLD_DELAY: 250,
  REDUX_PERSIST_VERSION_NUMBER: 86,
  REDUX_PERSIST_ACCOUNT_SLICE_VERSION: 24,
  SMART_BULLETIN_DEFAULT_HOUR: '00:00',
  SIX_HOURS_IN_SECONDS: 21600,
  ONE_DAY_IN_SECONDS: 86400,
  ONE_HOUR_IN_SECONDS: 3600,
  ONE_HOUR_IN_MILLISECONDS: 3600000,
  ONE_MINUTE_IN_MILLISECONDS: 60000,
  ONE_MONTH_IN_SECONDS: 2592000,
  ONE_WEEK_IN_SECONDS: 604800,
  TWO_WEEKS_IN_SECONDS: 1209600,
  MAX_ROWS_FOR_EXPORT_EXCEL: 300000,
  MIN_ROWS_FOR_EXPORT_EXCEL: 100,
  MIN_POSSIBLE_LENGTH_OF_WORD: 3,
  DEBOUNCE_DELAY: 1000,
  CHART_FETCH_DEBOUNCE_DELAY: 100,
  LAST_FORTY_DAYS: 40,
  LAST_YEAR_MONTHS: 13,
  EXPORT_EXCEL_MAX_TITLE_LENGTH: 100,
  ROOT_USER_ID: 1,
  ONE_DAY_IN_MILLISECONDS: 86400000,
  HUNDRED_PERCENT: 100,
  LAST_TWENTY_FOUR_HOURS: 24,
  CONVERT_TIMESTAMP_TO_DATE_FACTOR: 1000,
  ONE_SECOND: 1000,
  EVERY_FIFTEEN_MINUTES_IN_SECOND: 900,
  TABLET_BREAK_POINT: 900,
  MOBILE_BREAK_POINT: 600,
  BILLION: 1000000000,
  MILLION: 1000000,
  THOUSAND: 1000,
  HOVER_DECIMAL_DIGITS: 6,
  DESKTOP_NUMBER_OF_DISPLAYABLE_TAGS: 4,
  TABLET_NUMBER_OF_DISPLAYABLE_TAGS: 2,
  NUMBER_OF_DISPLAYABLE_TAG_CHARACTER: 20,
  DEFAULT_EXPANDED_ITEM_INDEX: null,
  AUTO_BULLETIN_DAY_TIME: 2,
  AUTO_BULLETIN_HOUR_TIME: 1,
  CAPTCHA_LENGTH: 4,
  SIDEBAR_WIDTH_WHEN_IS_EXPANDED: 258,
  SIDEBAR_WIDTH_WHEN_IS_NOT_EXPANDED: 80,
  ALARM_DAYS_LIMIT: 60,
  ALARM_CONTENT_SELECTED_SUBJECT: 1,
  ALARM_CONTENT_SELECTED_RESOURCE: 5,
  ALARM_REPORTING_STATISTICAL: 2,
  ALARM_REPORTING_NEGATIVE_ISSUES: 3,
  ALARM_REPORTING_TRENDING: 4,
  TWEET_CHARACTER_LIMIT: 280,
  LIMIT_OF_VISIBLE_STREAM_CONTENTS: 100,
  MAX_BULLETIN_CONTENT_QUERY_COUNT: 500,
  FILTER_SEARCH_RESULT_COUNT: 100,
  RESOURCE_LIST_PAGE_SIZE: 10,
  REPUBLISH_TIMELINE_PAGE_SIZE: 5,
  REPUBLISH_TIMELINE_CONTEXT_COUNT: 3,
  REPUBLISH_TIMELINE_LOAD_MORE_COUNT: 5,
  DIGIKALA_BRAND_SUMMARY_VISIBLE_NAMES: 2,
  ECOMMERCE_PIE_CHART_MOBILE_HEIGHT: 280,
  ECOMMERCE_PIE_CHART_DESKTOP_HEIGHT: 345,
};
